/* eslint-disable class-methods-use-this */
const apiUrl = 'https://vk.com/js/api/openapi.js?137';
const appId = '5824821';

class VkontakteApi {
  constructor() {
    this.api = typeof window !== 'undefined' ? window.VK || null : null;
    this.promise = null;
  }

  fetchScript(url) {
    return new Promise((resolve, reject) => {
      const transport = document.createElement('div');
      transport.id = 'vk_api_transport';
      document.body.appendChild(transport);

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = resolve;
      script.onerror = reject;
      script.src = url;
      script.async = 'async';
      transport.appendChild(script);
    });
  }

  load() {
    if (this.promise) return this.promise;

    this.promise = new Promise((resolve, reject) => {
      window.vkAsyncInit = () => {
        this.api = window.VK;
        this.api.init({
          apiId: appId,
        });
        resolve(this.api);
        window.vkAsyncInit = null;
      };

      this.fetchScript(apiUrl).catch(reject);
    });

    return this.promise;
  }

  get() {
    return new Promise((resolve, reject) => {
      if (this.api) {
        return resolve(this.api);
      }

      return this.load()
        .then((api) => {
          resolve(api);
        })
        .catch(() => reject);
    });
  }
}

export default new VkontakteApi();
